export default __webpack_public_path__ + "static/293-539ee091a659fc0f68ed8fdb7677748b.gif";